import React, { Component } from 'react';
import cn from 'classnames';
import debounce from 'lodash/debounce';
import { Dropdown } from './Dropdown';
import styles from './Autocomplete.scss';


export class Autocomplete extends Component {

  state = {
    query: '',
    items: [],
  };

  dropdown = React.createRef();
  input = React.createRef();
  onTypeCallback = null;

  componentDidMount(){
    const { onType } = this.props;
    this.onTypeCallback = debounce(onType, 300);
  }

  componentDidUpdate(prevProps){
    const { items } = this.props;
    if (items !== prevProps.items) {
      this.setState({ items });
    }
  }

  onInputChange = (e) => {
    const { showEmpty } = this.props;
    const query = e.target.value;
    this.setState({ query });

    if (query.trim().length || showEmpty) {
      this.onTypeCallback(query.trim());
      this.dropdown.current.openDropdown();
    }
    else {
      this.dropdown.current.manuallyCloseDropdown();
      this.setState({ items: [] });
    }
  };

  onDropdownChange = (selectedItem) => {
    const { onSelect, showEmpty, items } = this.props;
    this.setState({
      query: selectedItem.title,
      items: showEmpty ? items : [],
    });
    onSelect(selectedItem);
  };

  render(){
    const { className, placeholder, renderItem, overrideClassNames } = this.props;
    const { items, query } = this.state;

    return (
      <Dropdown
        ref={this.dropdown}
        items={items}
        renderItem={renderItem}
        onChange={this.onDropdownChange}
        overrideClassNames={{
          container: cn(className, styles.container),
          button: styles.dropdownButton,
          list: styles.dropdownList,
          ...overrideClassNames,
        }}>
        <input className={styles.input}
          ref={this.input}
          value={query}
          spellCheck={false}
          placeholder={placeholder}
          onChange={this.onInputChange}/>
      </Dropdown>
    );
  }
}
